import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {computed, ref} from 'vue';
    import {useStore} from 'vuex';
    import {useTranslation} from '@malt/vue3-use';
    import getters from '@/profile-creation-wizard/store/creation/getters';
    import ReroutingToOpenMarketplace from './ReroutingToOpenMarketplace.vue';
    import {ExperienceLevel} from '@/profile-creation-wizard/types';
    import {useRouter} from 'vue-router';
    import {inject} from 'vue';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ReroutingToOpenMarketplaceExperienceLevel',
  emits: ["experience-level-rerouting"],
  setup(__props, { emit }) {

    const trackingRepository = inject(DI.trackingRepository);
    const {msg} = useTranslation();
    const store = useStore();
    const router = useRouter();
    const selectedBackground = ref(store.getters[getters.selectedBackground]);
    const creationForm = ref(store.getters[getters.creationForm]);

    const eligibleExperienceLevels = [ExperienceLevel.EXPERT, ExperienceLevel.EXPERT_PLUS];

    

    const isVisible = computed(() => {
        if (!selectedBackground.value.interimExecutive || creationForm.value.experienceLevel === null) {
            emit('experience-level-rerouting', false);
            return false;
        }
        const hasTooLowExperienceLevel = !eligibleExperienceLevels.includes(creationForm.value.experienceLevel);
        emit('experience-level-rerouting', hasTooLowExperienceLevel);
        return hasTooLowExperienceLevel;
    });

    const trackReroute = function () {
        trackingRepository?.track('funnel-redirection-strategy', {
            reason: 'expertise',
        });
    };

return (_ctx: any,_cache: any) => {
  return (isVisible.value)
    ? (_openBlock(), _createBlock(ReroutingToOpenMarketplace, {
        key: 0,
        "data-testid": "rerouting-to-open-marketplace",
        title: _unref(msg)('profile.creation.wizard.strategy.categorization.rerouting.message.hasLowExperienceLevel.title'),
        line1: _unref(msg)('profile.creation.wizard.strategy.categorization.rerouting.message.hasLowExperienceLevel.line1'),
        line2: _unref(msg)('profile.creation.wizard.strategy.categorization.rerouting.message.hasLowExperienceLevel.line2'),
        onRerouteToMarketplace: trackReroute
      }, null, 8, ["title", "line1", "line2"]))
    : _createCommentVNode("", true)
}
}

})